<div>
  <div mat-dialog-title>New Version Available</div>
  <div mat-dialog-content>
    <div fxLayout="column" fxLayoutAlign="center center">
      <p>A new version of the website is available. Click update or refresh the browser to update.</p>
    </div>
  </div>
  <div mat-dialog-actions align="center"><button (click)="update()" mat-button>UPDATE</button><button mat-button
      (click)="close()">CLOSE</button></div>
</div>